import { render, staticRenderFns } from "./PostoAvancadoUm.vue?vue&type=template&id=76e01ebc&scoped=true"
import script from "./PostoAvancadoUm.vue?vue&type=script&lang=js"
export * from "./PostoAvancadoUm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e01ebc",
  null
  
)

export default component.exports